import React from 'react'
import { afboeLogo } from './misc'
import { _ } from './i18n'
import sortIcon from './sort.svg'

class GameInfo extends React.Component {

    handleSortClick( e ) {

        e.preventDefault()

        this.props.onToggleSort()

    }

    render() {

        const g = this.props.game

        return (

            <div className="game-info">

                <div className="logo"><img src={ 'data:image/jpeg;base64,' + afboeLogo } alt="" /></div>

                <div className="sort-switch">

                    <img src={sortIcon} alt="" /> <a href="/" onClick={ e => this.handleSortClick( e ) }>{ _( this.props.sort === 'name' ? 'Sort by Jersey №' : 'Sort by Name' ) }</a>

                </div>

                <h1>
                    { _( 'Game Roster' ) }
                    <span className="roster-status">{ _( g.rosterStatus === 'READY_TO_PLAY' ? 'OFFICIAL' : 'UNOFFICIAL' ) }</span>
                </h1>

                <table>

                    <tbody>

                        <tr>

                            <GameDetail label={ _( 'Game' ) } value={ g.gameName } />
                            <GameDetail label={ _( 'League' ) } value={ g.leagueName } />
                            <GameDetail label={ _( 'Home' ) } value={ g.homeTeamLongname } />
                            <GameDetail label={ _( 'Away' ) } value={ g.awayTeamLongname } />

                        </tr>

                        <tr>

                            <GameDetail label={ _( 'Date' ) } value={ g.scheduledDate.formattedShort } />
                            <GameDetail label={ _( 'Time' ) } value={ g.scheduledTime } />
                            <GameDetail label={ _( 'Location' ) } value={ g.location } colSpan="2" />

                        </tr>

                    </tbody>

                </table>

            </div>

        )

    }

}

class GameDetail extends React.Component {

    render() {

        return (

            <td colSpan={ this.props.colSpan || '1' }>

                <div>{ this.props.label }</div>
                <div className="large bold">{ this.props.value || <>&nbsp;</> }</div>

            </td>

        )

    }

}

export default GameInfo